import { InputChipData } from "@/shared/components/InputChipString/models/InputChipData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import { ListSelectDetails } from "../../models/ActionPlan.model";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";

@Component({
  name: "CardInputs",
  components: {
    DynamicSelect
  }
})
export default class CardInputs extends Vue {
  @Prop() listInputs!: ListSelectDetails[];

  TITLES = ACTION_PLAN_CONSTANTS.TITLES;

  selectInputs: ListSelectDetails[] = [];
  titleSelectField = "";
  selectField?: InputChipData;
  listSelectDynamic: ListSelectDetails[] = [];

  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: this.listInputs as [],
    filled: false,
    messageLabel: "",
    hideDetails: true
  };

  mounted() {
    this.listSelectDynamic = this.listInputs.map(item => {
      return {
        ...item,
        id: item.key
      };
    });
  }

  get selectInput() {
    return this.selectInputs[0];
  }
  set selectInput(value: ListSelectDetails) {
    this.selectInputs = [value];
    this.titleSelectField = "";
  }
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  removeSelectInput() {
    this.selectInputs = [];
    this.titleSelectField = "";
  }

  onSelectInput(field: any) {
    this.selectField = {
      name: this.selectInput.name,
      key: this.selectInput.key,
      type: this.selectInput.type ?? "",
      field: field
    };
    this.titleSelectField = field.title;
  }

  sendInput() {
    if (!this.selectField) {
      return;
    }
    this.$emit("pushField", this.selectField);
  }
}
